import { render, staticRenderFns } from "./custom_pages.vue?vue&type=template&id=b281a034&scoped=true&"
import script from "./custom_pages.vue?vue&type=script&lang=js&"
export * from "./custom_pages.vue?vue&type=script&lang=js&"
import style0 from "./custom_pages.vue?vue&type=style&index=0&id=b281a034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b281a034",
  null
  
)

export default component.exports